import { ReactNode } from 'react';

type TooltipPosition = 'top' | 'right' | 'bottom' | 'left';

interface TooltipProps {
  text: string;
  position?: TooltipPosition;
  show: boolean;
  children: ReactNode;
}

const Tooltip = ({ text, position = 'top', show, children }: TooltipProps) => {
  let tooltipClasses = '';

  switch (position) {
    case 'top':
      tooltipClasses = 'absolute left-1/2 transform -translate-x-1/2 bottom-full mb-2';
      break;
    case 'right':
      tooltipClasses = 'absolute top-1/2 transform -translate-y-1/2 left-full ml-2';
      break;
    case 'bottom':
      tooltipClasses = 'absolute left-1/2 transform -translate-x-1/2 top-full mt-2';
      break;
    case 'left':
      tooltipClasses = 'absolute top-1/2 transform -translate-y-1/2 right-full mr-2';
      break;
    default:
      tooltipClasses = 'absolute left-1/2 transform -translate-x-1/2 bottom-full mb-2';
  }

  return (
    <div className='relative group inline-block'>
      {children}
      {show && (
        <div
          role='tooltip'
          className={`${tooltipClasses} hidden group-hover:inline-block whitespace-nowrap bg-gray-800 text-white text-xs rounded py-1 px-2 z-10`}
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
